import styled from 'styled-components';

import variables from '../../styles/variables';

export const Button = styled.button<{
  active: boolean;
  phone: Record<string, any> | null;
}>`
  display: flex;
  position: relative;
  padding: 13px 10px;
  border: 1px solid #979797;
  background: ${({ active }) => (active ? `${variables.colorBlack}` : 'white')};
  color: ${({ active }) => (active ? 'white' : 'black')};
  border-radius: 10px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;

  span {
    margin-left: ${({ phone }) => (phone ? '0.5rem' : '0.3rem')};
    max-width: 100px;
    font-size: 14px;
    font-weight: 300;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  img {
    margin-left: 0.5rem;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
